module.exports = __webpack_public_path__ + "img/apple.06a9c99a.png";